import { Location } from 'history';

export const useQuery = (location: Location<any>) => {
  return new URLSearchParams(location.search);
};
